<div class="modal-container">
  <h1 mat-dialog-title>Encountered an error</h1>
  <div mat-dialog-content class="modal-container-input">
    <p>{{data.message}}</p>
  </div>
  <div mat-dialog-actions class="actions">
    <button mat-button (click)="onNoClick()">Ok</button>
  </div>
</div>
